module.exports = __webpack_public_path__ + "static/media/OurCompany3-EN.38f541b8.png";